module.exports = __webpack_public_path__ + "static/img/banner4.587cd96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner4.png
// module id = y+J+
// module chunks = 1